import { render } from "./FormDependentes.vue?vue&type=template&id=2ccdcdb0&scoped=true"
import script from "./FormDependentes.vue?vue&type=script&lang=js"
export * from "./FormDependentes.vue?vue&type=script&lang=js"

import "./FormDependentes.vue?vue&type=style&index=0&id=2ccdcdb0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccdcdb0"]])

export default __exports__